import { render } from "./AuthBanner.vue?vue&type=template&id=5f72a5b2&scoped=true"
import script from "./AuthBanner.vue?vue&type=script&lang=js"
export * from "./AuthBanner.vue?vue&type=script&lang=js"

import "./AuthBanner.vue?vue&type=style&index=0&id=5f72a5b2&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f72a5b2"]])

export default __exports__